import { AppointmentsRealTimeData } from 'src/generated/signalR/appointments-real-time-data';

export class AppointmentsUpdated {
   public static readonly type = '[Appointments] Update appointments';

   constructor(public data: AppointmentsRealTimeData) {}
}
